﻿export class ScreenLockService {

    public $rootScope: angular.IRootScopeService;

    public currentState;

    static $inject = ["$rootScope"];

    public constructor($rootScope: angular.IRootScopeService) {
        this.$rootScope = $rootScope;
    }

    public broadcast(state) {
        this.currentState = state;
        this.$rootScope.$broadcast("screenLock", { state });
    }

    public listen(callback) {
        this.$rootScope.$on("screenLock", callback);
    }


}